// import React, { useEffect, useState } from 'react'
// import Grid from '@mui/material/Grid2'
// import { Container, useMediaQuery } from '@mui/material'
// import { useNavigate } from "react-router-dom";
// import AtomButton from '../../atoms/button'
// import MenuItem from '@mui/material/MenuItem';
// import Select, { SelectChangeEvent } from '@mui/material/Select';
// import { BREAK_POINT_CONSTANTS } from '../../helpers/constant/constant'
// import AtomTextField from '../../atoms/textField'
// import AtomLink from '../../atoms/link/link'
// import { CirclePatternTop, ChevronRight, Facebook, Twitter, Linkedin } from '../../helpers/constant/imageUrl'
// import './careers.scss'
// import { useDispatch, useSelector } from 'react-redux';
// import { AppDispatch, RootState } from '../../redux/storage/store';
// import { displayPartsToString } from 'typescript';
// import { fetchCareer } from '../../redux/slice/configSlice';
// import Loader from '../../Component/Loader';

// const CareerTemplate = () => { 
//     const navigate = useNavigate();
//     const breakPointIpad = useMediaQuery(`(${BREAK_POINT_CONSTANTS.IPAD})`)
//     const {careers} = useSelector((state:RootState)=>state.config);
//     const [loading,setLoading] = useState(true);
//     const dispatch = useDispatch<AppDispatch>();
//     const [currentTab, setCurrentTab] = useState(0)
//     const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => {
//         setCurrentTab(newValue)
//     }
//     useEffect(()=>{

//         dispatch(fetchCareer()).then(()=>{
//             setLoading(false);
//         }).catch(()=>{
//             alert("Error occured while fetching careers")
//         });
//     },[dispatch])
//     return (
//         <div className="careers">
//             <div className='gradient-section'>
//                 <div className='pattern-top'>
//                     <img src={CirclePatternTop} alt='' />
//                 </div>
//                 <div className='pattern-bottom'>
//                     <img src={CirclePatternTop} alt='' />
//                 </div>
//                 <Container className='container'>
//                     <h1>Join Our Team</h1>
//                     <p>We offer a dynamic and inclusive work environment where innovation and professional growth thrive. Explore our career opportunities and contribute to our journey towards excellence and sustainability.</p>
//                     <AtomButton 
//                         variant='contained' 
//                         color='primary' 
//                         size={breakPointIpad ? 'large' : 'small'}
//                         endIcon={
//                             <img src={ChevronRight} alt='' />
//                         }                                   
//                     >
//                         CURRENT JOB OPENINGS
//                     </AtomButton>
//                 </Container>
//             </div>
//             <div className='job-opening'>
//                 <Container className='container'>
//                     <div className='form-section'>
//                         <div className='form'>
//                             <Grid container spacing={{ xs: 1.26 }}>
//                                 <Grid size={{ xs: 12, md: 3.4, lg: 3.5 }}>
//                                     <AtomTextField name="" placeholder='Search' />
//                                 </Grid>
//                                 <Grid size={{ xs: 12, md: 'auto' }}>
//                                     <div className='divider'></div>
//                                 </Grid>
//                                 <Grid size={{ xs: 12, md: 3.4, lg: 3.5 }}>
//                                     <Select
//                                         id="Level"
//                                         displayEmpty
//                                         renderValue={(selected: any) => {
//                                             if (!selected) {
//                                               return <span>Level</span>;
//                                             }     

//                                             return selected;
//                                         }}
//                                     >
//                                         <MenuItem value={'Entry Level'}>Entry Level</MenuItem>
//                                         <MenuItem value={'Fresher of 1 to 2 years'}>Fresher of 1 to 2 years</MenuItem>
//                                         <MenuItem value={'2+ Years of Experience'}>2+ Years of Experience</MenuItem>
//                                         <MenuItem value={'4+ Years of Experience'}>4+ Years of Experience</MenuItem>
//                                         <MenuItem value={'6+ Years of Experience'}>6+ Years of Experience</MenuItem>
//                                         <MenuItem value={'8+ Years of Experience'}>8+ Years of Experience</MenuItem>
//                                         <MenuItem value={'More than 10 Years of Experience'}>More than 10 Years of Experience</MenuItem>
//                                     </Select>
//                                 </Grid>
//                                 <Grid size={{ xs: 12, md: 'auto' }}>
//                                     <div className='divider'></div>
//                                 </Grid>
//                                 <Grid size={{ xs: 12, md: 3.4, lg: 3.5 }}>
//                                     <Select
//                                         id="JobType"
//                                         displayEmpty
//                                         renderValue={(selected: any) => {
//                                             if (!selected) {
//                                               return <span>Job Type</span>;
//                                             }     

//                                             return selected;
//                                         }}
//                                     >
//                                         <MenuItem value={'Full Time'}>Full Time</MenuItem>
//                                         <MenuItem value={'Permanent'}>Permanent</MenuItem>
//                                     </Select>
//                                 </Grid>
//                                 <Grid size={{ xs: 12, md: 'auto' }}>
//                                     <AtomButton 
//                                         variant='contained' 
//                                         color='primary' 
//                                         fullWidth={breakPointIpad ? false : true}                             
//                                     >
//                                         go
//                                     </AtomButton>
//                                 </Grid>
//                             </Grid>
//                         </div>
//                     </div>
//                     <Grid container spacing={{ xs: 1.26, md: 3 }}>
//                         <Grid size={{ xs: 12, sm: 6, md: 4 }}>
//                             {
//                             loading ? <Loader/> : (Array.isArray(careers) && careers?.length>0) ?  (careers)?.map((career:any)=>{
//                                 return(
//                                     <div className='blue-card'>
//                                     <div className='experience'>{career.experienceLevel}</div>
//                                     <h4>{career.jobTitle}</h4>
//                                     <p>{career.jobDescription}</p>
//                                     <h5>Job Type</h5>
//                                     <p>{career.jobType}</p>
//                                     <AtomButton 
//                                         variant = {'outlined'}
//                                         size = {'small'}
//                                         endIcon={
//                                             <img src={ChevronRight} alt='' />
//                                         }
//                                     >
//                                         LEARN MORE
//                                     </AtomButton>
//                                 </div> 
//                                 )
//                             }) :
//                             <div>No Current careers opening</div>}

//                         </Grid>
//                     </Grid>
//                     <div className='text-center mt-10'>
//                         <AtomButton 
//                             variant = {'outlined'}
//                             size = {'large'}
//                             endIcon={
//                                 <img src={ChevronRight} alt='' />
//                             }
//                         >
//                             VIEW MORE
//                         </AtomButton>
//                     </div>
//                 </Container>
//             </div>
//             <div className='get-in-touch'>
//                 <Container className='container'>
//                     <Grid container alignItems={'center'}>
//                         <Grid size={{ xs: 12, md: 5 }} className="column">
//                             <h5>Get in touch</h5>
//                             <div className='mt-8'>
//                                 <h6>COMPANY EMAIL</h6>
//                                 <AtomLink 
//                                     href="mailto:kop@kumarorganic.net"
//                                 >
//                                     kop@kumarorganic.net
//                                 </AtomLink>
//                             </div>
//                             <div className='mt-8'>
//                                 <h6>HR SUPPORT</h6>
//                                 <AtomLink 
//                                     href="mailto:kop@kumarorganic.net"
//                                 >
//                                     hr1@kumarorganic.net
//                                 </AtomLink>
//                             </div>
//                             <div className='mt-8'>
//                                 <ul className='social'>
//                                     <li>
//                                         <AtomLink 
//                                             href=""
//                                         >
//                                             <img src={Facebook} alt='' />
//                                         </AtomLink>
//                                     </li>
//                                     <li>
//                                         <AtomLink 
//                                             href=""
//                                         >
//                                             <img src={Twitter} alt='' />
//                                         </AtomLink>
//                                     </li>
//                                     <li>
//                                         <AtomLink 
//                                             href=""
//                                         >
//                                             <img src={Linkedin} alt='' />
//                                         </AtomLink>
//                                     </li>
//                                 </ul>
//                             </div>
//                         </Grid>
//                         <Grid size={{ xs: 12, md: 7 }}>
//                             <div className='white-card'>
//                                 <Grid container spacing={{ xs: 2 }}>
//                                     <Grid size={{ xs: 12, sm: 6 }}>
//                                         <AtomTextField name="First Name" placeholder='First Name' />
//                                     </Grid>
//                                     <Grid size={{ xs: 12, sm: 6 }}>
//                                         <AtomTextField name="Product" placeholder='Product' />
//                                     </Grid>
//                                     <Grid size={{ xs: 12, sm: 6 }}>
//                                         <AtomTextField name="Phone Number" placeholder='Phone Number' />
//                                     </Grid>
//                                     <Grid size={{ xs: 12, sm: 6 }}>
//                                         <AtomTextField name="Email Address" placeholder='Email Address' />
//                                     </Grid>
//                                     <Grid size={{ xs: 12 }}>
//                                         <Select
//                                             id="JobType"
//                                             displayEmpty
//                                             renderValue={(selected: any) => {
//                                                 if (!selected) {
//                                                 return <span>Select Position</span>;
//                                                 }     

//                                                 return selected;
//                                             }}
//                                         >
//                                             <MenuItem value={'Development'}>Development</MenuItem>
//                                         </Select>
//                                     </Grid>
//                                     <Grid size={{ xs: 12 }}>
//                                         <AtomTextField name="Message" multiline={true} minRows={4} placeholder='Message' />
//                                     </Grid>
//                                 </Grid>
//                                 <div className='mt-8 text-center'>
//                                     <AtomButton 
//                                         variant='contained' 
//                                         color='primary' 
//                                         endIcon={
//                                             <img src={ChevronRight} alt='' />
//                                         }
//                                     >
//                                         Request a call
//                                     </AtomButton>
//                                 </div>
//                             </div>
//                         </Grid>
//                     </Grid>
//                 </Container>
//             </div>
//         </div>
//     )
// }

// export default CareerTemplate
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import Grid from '@mui/material/Grid';
// import { Container, useMediaQuery } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import AtomButton from '../../atoms/button';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
// import { BREAK_POINT_CONSTANTS } from '../../helpers/constant/constant';
// import AtomTextField from '../../atoms/textField';
// import { CirclePatternTop, ChevronRight } from '../../helpers/constant/imageUrl';
// import './careers.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import { AppDispatch, RootState } from '../../redux/storage/store';
// import { fetchCareer } from '../../redux/slice/configSlice';
// import Loader from '../../Component/Loader';
// import { EXPERIENCE_LEVELS, JOB_TYPES } from '../../constants/careers';
// import getCareersFromFirebase from '../../services/careerService';
// import { toast } from 'react-toastify';
// import { useConfigStore } from '../../redux/hooks/useConfigStore';


// interface Career {
//   id: string;
//   jobTitle: string;
//   jobDescription: string;
//   jobType: string;
//   experienceLevel: string;
//   maxExperienceLevel:string;
// }

// const CareerTemplate = () => {
//   const {storeCareer} = useConfigStore();
//   const navigate = useNavigate();
//   const dispatch = useDispatch<AppDispatch>();
//   const breakPointIpad = useMediaQuery(`(${BREAK_POINT_CONSTANTS.IPAD})`);
//   const { careers:careerData } = useSelector((state: RootState) => state.config);
//   const [lastVisible, setLastVisible] = useState<any>(null);
//   const [hasMore, setHasMore] = useState(true);
//   const isFetchingRef = useRef(false);
//   const [careers, setCareers] = useState<Career[]>([]);

//   const [loading, setLoading] = useState(true);

//   // Search form state (inputs)
//   const [searchText, setSearchText] = useState('');
//   const [level, setLevel] = useState('');
//   const [jobType, setJobType] = useState('');

//   // Filter state (applied after clicking GO)
//   const [filterText, setFilterText] = useState('');
//   const [filterLevel, setFilterLevel] = useState('');
//   const [filterJobType, setFilterJobType] = useState('');

//   // useEffect(() => {
//   //   dispatch(fetchCareer())
//   //     .then(() => setLoading(false))
//   //     .catch(() => alert('Error occurred while fetching careers'));
//   // }, [dispatch]);

//   useEffect(()=>{
//     handleApplyFilters();
//   },[searchText, level, jobType])

  
//   const handleApplyFilters = () => {
//     setFilterText(searchText);
//     setFilterLevel(level);
//     setFilterJobType(jobType);
//   };
 
 
//   const filteredCareers = useMemo(() => {
     
//     return (careers || []).filter((job: Career) => {
//       const matchesSearch = filterText.trim()
//         ? job.jobTitle?.toLowerCase().includes(filterText.toLowerCase())
//         : true;

//       const matchesLevel = filterLevel
//         ? filterLevel === "0" ? job.experienceLevel < "1" :
//         job.experienceLevel >= filterLevel.toLowerCase()
//         : true;

//       const matchesJobType = filterJobType
//         ? job.jobType?.toLowerCase() === filterJobType.toLowerCase()
//         : true;

//       return matchesSearch && matchesLevel && matchesJobType;
//     });
//   }, [careers, filterText, filterLevel, filterJobType]);


//   useEffect(() => {
//       fetchInitialCareers();
//     }, []);
  
//     const fetchInitialCareers = async () => {
//       try {
//         setLoading(true);
//         const { careers: initial, lastVisible } = await getCareersFromFirebase(6);
//         setCareers(initial);
//         storeCareer(initial);
//         setLastVisible(lastVisible);
//         if (initial.length < 6) setHasMore(false);
//       } catch (err) {
//         toast.error("Failed to load careers.");
//       } finally {
//         setLoading(false);
//       }
//     };



  
//     const fetchNextCareers = async () => {
//       if (isFetchingRef.current || !hasMore) return;
//       isFetchingRef.current = true;
//       try {
//         const { careers: next, lastVisible: newLastVisible } = await getCareersFromFirebase(6, lastVisible);
//         setCareers((prev) => {
//           const updated = [...prev, ...next]
//           storeCareer(updated);
//           return updated;
//         });
//         setLastVisible(newLastVisible);
//         if (next.length < 6) setHasMore(false);
//       } catch (err) {
//         toast.error("Failed to load more careers.");
//       } finally {
//         isFetchingRef.current = false;
//       }
//     };

//   return (
//     <div className="careers">
//       <div className="gradient-section">
//         <div className="pattern-top">
//           <img src={CirclePatternTop} alt="" />
//         </div>
//         <div className="pattern-bottom">
//           <img src={CirclePatternTop} alt="" />
//         </div>
//         <Container className="container">
//           <h1>Join Our Team</h1>
//           <p>
//             We offer a dynamic and inclusive work environment where innovation and professional growth thrive.
//           </p>
//           <AtomButton
//             variant="contained"
//             color="primary"
//             size={breakPointIpad ? 'large' : 'small'}
//             endIcon={<img src={ChevronRight} alt="" />}
//           >
//             CURRENT JOB OPENINGS
//           </AtomButton>
//         </Container>
//       </div>

//       <div className="job-opening">
//         <Container className="container">
//           <div className="form-section">
//             <div className="form">
//               <Grid container spacing={2} alignItems="center">
//                 <Grid item xs={12} md={3}>
//                   <AtomTextField
//                     name="search"
//                     placeholder="Search"
//                     value={searchText}
//                     onChange={(e) => setSearchText(e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                  <Select
//       fullWidth
//       value={level}
//       displayEmpty
//       onChange={(e) => setLevel(e.target.value)}
//       renderValue={(selected) => {
//         const selectedType = EXPERIENCE_LEVELS.find((type) => type.value === selected);
//     return <span>{selectedType?.label || 'All'}</span>;}}
//     >
//       {EXPERIENCE_LEVELS.map(({ label, value }) => (
//         <MenuItem key={value} value={value}>
//           {label}
//         </MenuItem>
//       ))}
//     </Select>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                   <Select
//                     fullWidth
//                     value={jobType}
//                     displayEmpty
//                     onChange={(e) => setJobType(e.target.value)}
//                     renderValue={(selected) => {
//                       const selectedType = JOB_TYPES.find((type) => type.value === selected);
//                       return <span>{selectedType?.label || 'All'}</span>;}}
//                   >
                    
//                     {JOB_TYPES?.map((jobType)=>(
//                       <MenuItem value={jobType.value}>{jobType.label}</MenuItem>
//                     ))}
//                   </Select>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                   <AtomButton fullWidth variant="contained" color="primary" onClick={handleApplyFilters}>
//                     GO
//                   </AtomButton>
//                 </Grid>
//               </Grid>
//             </div>
//           </div>

//           <Grid container spacing={3} className="mt-4">
//             {loading ? (
//               <Loader />
//             ) : filteredCareers.length > 0 ? (
//               filteredCareers.map((career: Career) => (
//                 <Grid item xs={12} sm={6} md={4} key={career.id}>
//                   <div className="blue-card">
//                     <div className="experience">{career.experienceLevel} - {career?.maxExperienceLevel || 'Max'} Years</div>
//                     <h4>{career.jobTitle}</h4>
//                     <p>{career.jobDescription}</p>
//                     <h5>Job Type</h5>
//                     <p>{career.jobType}</p>
//                     <AtomButton
//                       variant="outlined"
//                       size="small"
//                       endIcon={<img src={ChevronRight} alt="" />}
//                       onClick={() => navigate(`/career/${career.id}`)}
//                     >
//                       LEARN MORE
//                     </AtomButton>
//                   </div>
//                 </Grid>
//               ))
//             ) : (
//               <Grid item xs={12}>
//                 <div>No Current Careers Opening</div>
//               </Grid>
//             )}
//           </Grid>

//           <div className="text-center mt-10">
//             <AtomButton variant="outlined" size="large" endIcon={<img src={ChevronRight} alt="" />} onClick={fetchNextCareers}>
//               VIEW MORE
//             </AtomButton>
//           </div>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default CareerTemplate;


// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import Grid from '@mui/material/Grid';
// import { Container, useMediaQuery } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import AtomButton from '../../atoms/button';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
// import { BREAK_POINT_CONSTANTS } from '../../helpers/constant/constant';
// import AtomTextField from '../../atoms/textField';
// import { CirclePatternTop, ChevronRight } from '../../helpers/constant/imageUrl';
// import './careers.scss';
// import { useDispatch, useSelector } from 'react-redux';
// import { AppDispatch, RootState } from '../../redux/storage/store';
// import Loader from '../../Component/Loader';
// import { EXPERIENCE_LEVELS, JOB_TYPES } from '../../constants/careers';
// import getCareersFromFirebase from '../../services/careerService';
// import { toast } from 'react-toastify';
// import { useConfigStore } from '../../redux/hooks/useConfigStore';

// interface Career {
//   id: string;
//   jobTitle: string;
//   jobDescription: string;
//   jobType: string;
//   experienceLevel: string;
//   maxExperienceLevel: string;
// }

// const CareerTemplate = () => {
//   const { storeCareer } = useConfigStore();
//   const navigate = useNavigate();
//   const dispatch = useDispatch<AppDispatch>();
//   const breakPointIpad = useMediaQuery(`(${BREAK_POINT_CONSTANTS.IPAD})`);
//   const { careers: careerData } = useSelector((state: RootState) => state.config);
//   const [lastVisible, setLastVisible] = useState<any>(null);
//   const [hasMore, setHasMore] = useState(true);
//   const isFetchingRef = useRef(false);
//   const [careers, setCareers] = useState<Career[]>([]);
//   const [loading, setLoading] = useState(true);

//   // Input form state
//   const [searchText, setSearchText] = useState('');
//   const [level, setLevel] = useState('');
//   const [jobType, setJobType] = useState('');

//   // Filter state applied on GO click
//   const [filterText, setFilterText] = useState('');
//   const [filterLevel, setFilterLevel] = useState('');
//   const [filterJobType, setFilterJobType] = useState('');

//   const handleApplyFilters = async() => {
//      setLoading(true);
//     setFilterText(searchText);
//     setFilterLevel(level);
//     setFilterJobType(jobType);
//   };

//   const filteredCareers = useMemo(() => {
//     return (careers || []).filter((job: Career) => {
//       const matchesSearch = filterText.trim()
//         ? job.jobTitle?.toLowerCase().includes(filterText.toLowerCase())
//         : true;

//       const matchesLevel = filterLevel
//         ? filterLevel === '0'
//           ? Number(job.experienceLevel) < 1
//           : Number(job.experienceLevel) >= Number(filterLevel)
//         : true;

//       const matchesJobType = filterJobType
//         ? job.jobType?.toLowerCase() === filterJobType.toLowerCase()
//         : true;

//       return matchesSearch && matchesLevel && matchesJobType;
//     });
//   }, [careers, filterText, filterLevel, filterJobType]);

//   useEffect(() => {
//     fetchInitialCareers();
//   }, []);

//   const fetchInitialCareers = async () => {
//     try {
//       setLoading(true);
//       const { careers: initial, lastVisible } = await getCareersFromFirebase(6);
//       setCareers(initial);
//       storeCareer(initial);
//       setLastVisible(lastVisible);
//       if (initial.length < 6) setHasMore(false);
//     } catch (err) {
//       toast.error('Failed to load careers.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchNextCareers = async () => {
//     if (isFetchingRef.current || !hasMore) return;
//     isFetchingRef.current = true;
//     try {
//       const { careers: next, lastVisible: newLastVisible } = await getCareersFromFirebase(6, lastVisible);
//       setCareers((prev) => {
//         const updated = [...prev, ...next];
//         storeCareer(updated);
//         return updated;
//       });
//       setLastVisible(newLastVisible);
//       if (next.length < 6) setHasMore(false);
//     } catch (err) {
//       toast.error('Failed to load more careers.');
//     } finally {
//       isFetchingRef.current = false;
//     }
//   };

//   return (
//     <div className="careers">
//       <div className="gradient-section">
//         <div className="pattern-top">
//           <img src={CirclePatternTop} alt="" />
//         </div>
//         <div className="pattern-bottom">
//           <img src={CirclePatternTop} alt="" />
//         </div>
//         <Container className="container">
//           <h1>Join Our Team</h1>
//           <p>
//             We offer a dynamic and inclusive work environment where innovation and professional growth thrive.
//           </p>
//           <AtomButton
//             variant="contained"
//             color="primary"
//             size={breakPointIpad ? 'large' : 'small'}
//             endIcon={<img src={ChevronRight} alt="" />}
//           >
//             CURRENT JOB OPENINGS
//           </AtomButton>
//         </Container>
//       </div>

//       <div className="job-opening">
//         <Container className="container">
//           <div className="form-section">
//             <div className="form">
//               <Grid container spacing={2} alignItems="center">
//                 <Grid item xs={12} md={3}>
//                   <AtomTextField
//                     name="search"
//                     placeholder="Search"
//                     value={searchText}
//                     onChange={(e) => setSearchText(e.target.value)}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                   <Select
//                     fullWidth
//                     value={level}
//                     displayEmpty
//                     onChange={(e) => setLevel(e.target.value)}
//                     renderValue={(selected) => {
//                       const selectedType = EXPERIENCE_LEVELS.find((type) => type.value === selected);
//                       return <span>{selectedType?.label || 'All'}</span>;
//                     }}
//                   >
//                     {EXPERIENCE_LEVELS.map(({ label, value }) => (
//                       <MenuItem key={value} value={value}>
//                         {label}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                   <Select
//                     fullWidth
//                     value={jobType}
//                     displayEmpty
//                     onChange={(e) => setJobType(e.target.value)}
//                     renderValue={(selected) => {
//                       const selectedType = JOB_TYPES.find((type) => type.value === selected);
//                       return <span>{selectedType?.label || 'All'}</span>;
//                     }}
//                   >
//                     {JOB_TYPES?.map((jobType) => (
//                       <MenuItem key={jobType.value} value={jobType.value}>
//                         {jobType.label}
//                       </MenuItem>
//                     ))}
//                   </Select>
//                 </Grid>
//                 <Grid item xs={12} md={3}>
//                   <AtomButton fullWidth variant="contained" color="primary" onClick={handleApplyFilters}>
//                     GO
//                   </AtomButton>
//                 </Grid>
//               </Grid>
//             </div>
//           </div>

//           <Grid container spacing={3} className="mt-4">
//             {loading ? (
//               <Loader />
//             ) : filteredCareers.length > 0 ? (
//               filteredCareers.map((career: Career) => (
//                 <Grid item xs={12} sm={6} md={4} key={career.id}>
//                   <div className="blue-card">
//                     <div className="experience">
//                       {career.experienceLevel} - {career?.maxExperienceLevel || 'Max'} Years
//                     </div>
//                     <h4>{career.jobTitle}</h4>
//                     <p>{career.jobDescription}</p>
//                     <h5>Job Type</h5>
//                     <p>{career.jobType}</p>
//                     <AtomButton
//                       variant="outlined"
//                       size="small"
//                       endIcon={<img src={ChevronRight} alt="" />}
//                       onClick={() => navigate(`/career/${career.id}`)}
//                     >
//                       LEARN MORE
//                     </AtomButton>
//                   </div>
//                 </Grid>
//               ))
//             ) : (
//               <Grid item xs={12}>
//                 <div>No Current Careers Opening</div>
//               </Grid>
//             )}
//           </Grid>

//           <div className="text-center mt-10">
//             <AtomButton variant="outlined" size="large" endIcon={<img src={ChevronRight} alt="" />} onClick={fetchNextCareers}>
//               VIEW MORE
//             </AtomButton>
//           </div>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default CareerTemplate;

import React, { useEffect, useMemo, useRef, useState } from 'react';
import Grid from '@mui/material/Grid';
import { Container, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AtomButton from '../../atoms/button';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { BREAK_POINT_CONSTANTS } from '../../helpers/constant/constant';
import AtomTextField from '../../atoms/textField';
import { CirclePatternTop, ChevronRight } from '../../helpers/constant/imageUrl';
import './careers.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/storage/store';
import Loader from '../../Component/Loader';
import { EXPERIENCE_LEVELS, JOB_TYPES } from '../../constants/careers';
import getCareersFromFirebase from '../../services/careerService';
import { toast } from 'react-toastify';
import { useConfigStore } from '../../redux/hooks/useConfigStore';

interface Career {
  id: string;
  jobTitle: string;
  jobDescription: string;
  jobType: string;
  experienceLevel: string;
  maxExperienceLevel: string;
}

const CareerTemplate = () => {
  const { storeCareer } = useConfigStore();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const breakPointIpad = useMediaQuery(`(${BREAK_POINT_CONSTANTS.IPAD})`);
  const { careers: careerData } = useSelector((state: RootState) => state.config);
  const [lastVisible, setLastVisible] = useState<any>(null);
  const [hasMore, setHasMore] = useState(true);
  const isFetchingRef = useRef(false);
  const [careers, setCareers] = useState<Career[]>([]);
  const [loading, setLoading] = useState(true);

  // Input form state
  const [searchText, setSearchText] = useState('');
  const [level, setLevel] = useState('');
  const [jobType, setJobType] = useState('');

  // Filter state applied on GO click (used for server-side query)
  const [filterText, setFilterText] = useState('');
  const [filterLevel, setFilterLevel] = useState('');
  const [filterJobType, setFilterJobType] = useState('');

  // When user clicks GO, call filtered data from Firebase
  const handleApplyFilters = async () => {
    setLoading(true);
    setHasMore(true);
    setLastVisible(null);

    setFilterText(searchText);
    setFilterLevel(level);
    setFilterJobType(jobType);

    try {
      // Prepare filter object for Firebase query
      const filters: any = {};

      if (searchText.trim()) {
        filters.searchText = searchText.trim().toLowerCase(); 
        // Note: Firestore can't do text contains natively, you may need to handle this specially or via a search index.
        // For now we ignore this filter on server side or do client-side filter after fetching.
      }

      if (level) filters.experienceLevel = level;
      if (jobType) filters.jobType = jobType;

      // Fetch filtered careers from Firebase
      const { careers: filteredCareers, lastVisible: newLastVisible } = await getCareersFromFirebase(
        6,
        null,
        filters
      );

      setCareers(filteredCareers);
      storeCareer(filteredCareers);
      setLastVisible(newLastVisible);
      if (filteredCareers.length < 6) setHasMore(false);
    } catch (error) {
      toast.error('Failed to load filtered careers.');
    } finally {
      setLoading(false);
    }
  };

  // Initial load without filters
  const fetchInitialCareers = async () => {
    try {
      setLoading(true);
      const { careers: initial, lastVisible } = await getCareersFromFirebase(6);
      setCareers(initial);
      storeCareer(initial);
      setLastVisible(lastVisible);
      if (initial.length < 6) setHasMore(false);
    } catch (err) {
      toast.error('Failed to load careers.');
    } finally {
      setLoading(false);
    }
  };

  // Pagination with current filter applied
  const fetchNextCareers = async () => {
    if (isFetchingRef.current || !hasMore) return;
    isFetchingRef.current = true;

    try {
      const filters: any = {};
      if (filterLevel) filters.experienceLevel = filterLevel;
      if (filterJobType) filters.jobType = filterJobType;
      // searchText filtering on server is complex, you can do client-side after fetch

      const { careers: next, lastVisible: newLastVisible } = await getCareersFromFirebase(
        6,
        lastVisible,
        filters
      );

      setCareers((prev) => {
        const updated = [...prev, ...next];
        storeCareer(updated);
        return updated;
      });
      setLastVisible(newLastVisible);
      if (next.length < 6) setHasMore(false);
    } catch (err) {
      toast.error('Failed to load more careers.');
    } finally {
      isFetchingRef.current = false;
    }
  };

  useEffect(() => {
    fetchInitialCareers();
  }, []);

  // Client side filter for search text (optional)
  const filteredCareers = useMemo(() => {
    if (!filterText.trim()) return careers;
    return careers.filter((job) =>
      job.jobTitle.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [careers, filterText]);

  return (
    <div className="careers">
      <div className="gradient-section">
        <div className="pattern-top">
          <img src={CirclePatternTop} alt="CirclePattern" />
        </div>
        <div className="pattern-bottom">
          <img src={CirclePatternTop} alt="CirclePattern" />
        </div>
        <Container className="container">
          <h1>Join Our Team</h1>
          <p>
            We offer a dynamic and inclusive work environment where innovation and professional growth thrive.
          </p>
          <AtomButton
            variant="contained"
            color="primary"
            size={breakPointIpad ? 'large' : 'small'}
            endIcon={<img src={ChevronRight} alt="ChevronRight" />}
          >
            CURRENT JOB OPENINGS
          </AtomButton>
        </Container>
      </div>

      <div className="job-opening">
        <Container className="container">
          <div className="form-section">
            <div className="form">
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={3}>
                  <AtomTextField
                    name="search"
                    placeholder="Search"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Select
                    fullWidth
                    value={level}
                    displayEmpty
                    onChange={(e) => setLevel(e.target.value)}
                    renderValue={(selected) => {
                      const selectedType = EXPERIENCE_LEVELS.find((type) => type.value === selected);
                      return <span>{selectedType?.label || 'All'}</span>;
                    }}
                  >
                    {EXPERIENCE_LEVELS.map(({ label, value }) => (
                      <MenuItem key={value} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Select
                    fullWidth
                    value={jobType}
                    displayEmpty
                    onChange={(e) => setJobType(e.target.value)}
                    renderValue={(selected) => {
                      const selectedType = JOB_TYPES.find((type) => type.value === selected);
                      return <span>{selectedType?.label || 'All'}</span>;
                    }}
                  >
                    {JOB_TYPES?.map((jobType) => (
                      <MenuItem key={jobType.value} value={jobType.value}>
                        {jobType.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={12} md={3}>
                  <AtomButton fullWidth variant="contained" color="primary" onClick={handleApplyFilters}>
                    GO
                  </AtomButton>
                </Grid>
              </Grid>
            </div>
          </div>

          <Grid container spacing={3} className="mt-4">
            {loading ? (
              <Loader />
            ) : filteredCareers.length > 0 ? (
              filteredCareers.map((career: Career) => (
                <Grid item xs={12} sm={6} md={4} key={career.id}>
                  <div className="blue-card">
                    <div className="experience">
                      {career.experienceLevel} - {career?.maxExperienceLevel || 'Max'} Years
                    </div>
                    <h4>{career.jobTitle}</h4>
                    <p>{career.jobDescription}</p>
                    <h5>Job Type</h5>
                    <p>{career.jobType}</p>
                    <AtomButton
                      variant="outlined"
                      size="small"
                      endIcon={<img src={ChevronRight} alt="ChevronRight" />}
                      onClick={() => navigate(`/career/${career.id}`)}
                    >
                      LEARN MORE
                    </AtomButton>
                  </div>
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <div>No Current Careers Opening</div>
              </Grid>
            )}
          </Grid>

          <div className="text-center mt-10">
            <AtomButton variant="outlined" size="large" endIcon={<img src={ChevronRight} alt="ChevronRight" />} onClick={fetchNextCareers}>
              VIEW MORE
            </AtomButton>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default CareerTemplate;
